// import wj from '@/plugins/wjtools'

export default {
  setToken (state, payload) {
    state.token = payload
  },

  setUserInfo (state, payload = {}) {
    state.userInfo = payload
    localStorage.setItem('userInfo', JSON.stringify(payload))
  },
}
